
<img *ngIf="loading" [src]="defaultImage" alt="loading" class="sprite-image-loading" [class]="classes" />
<ng-container *ngIf="!loading">
    <img *ngIf="!error" [src]="imagePath" [class]="classes" [alt]="alt">
    <span *ngIf="error && !defaultImage">Error loading image</span>
    <img *ngIf="error && defaultImage" [src]="defaultImage" [alt]="alt" [class]="classes" />
</ng-container>
